import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const DateIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Date",
    children: /*#__PURE__*/_jsx("path", {
      d: "M9.24 15.51h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96H9.24a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96m5.78 0h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96h-1.93a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96m5.79 0h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96h-1.93a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96M9.23 21.3h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96H9.23a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96m5.78 0h1.93c.53 0 .96.43.96.96v1.93c0 .53-.43.96-.96.96h-1.93a.96.96 0 0 1-.96-.96v-1.93c0-.53.43-.96.96-.96M10.69 2h-.05c-.8 0-1.45.65-1.45 1.45v2.41H6.83c-1.85 0-3.36 1.49-3.38 3.33v17.42c0 1.87 1.51 3.38 3.38 3.38h13.55c.38 0 .73-.15.99-.39s6.81-6.8 6.81-6.8c.23-.26.38-.6.38-.97V9.19c0-1.87-1.51-3.38-3.38-3.38h-2.36V3.45c0-.8-.65-1.45-1.45-1.45h-.05c-.79.02-1.42.66-1.42 1.45v2.41h-7.78V3.45c0-.79-.63-1.43-1.42-1.45ZM6.8 27.1a.49.49 0 0 1-.49-.49V13.58h19.34v7.6l-.12.12h-3.7c-1.07 0-1.94.87-1.94 1.94v3.73l-.12.12H6.8Z"
    })
  }));
};